import { EntityBase } from './EntityBase';
import { Survey } from './Survey';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class SurveyAndCompany extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   surveyAndCompanyId: number;
   surveyId: number;
   companyName: string;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   survey: Survey;
}

